import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import styled from "@emotion/styled";
import { radioTheme } from "./styles";

const StyledRadioButton = styled.label`
  ${({ theme }) => {
    return theme ? radioTheme?.[theme] : "";
  }};
`;

const RadioButton = ({
  id,
  name,
  label,
  value,
  type,
  checked,
  style,
  onChange,
  className = "",
  theme = "circle",
}) => {
  const isChecked = checked && theme === "circle";

  const getIcon = () => {
    if (isChecked) {
      return <CircleIcon className="icon" />;
    } else if (checked) {
      return <CloseIcon />;
    }
    return null;
  };
  const getCheckedClass = (isChecked, baseClassName) => {
    if (isChecked) {
      const checkedSuffix = baseClassName ? ` ${baseClassName}-checked` : "";
      return `svg-checked${checkedSuffix}`;
    }
    return "";
  };
  const svgBlockClass = `svg-block ${className} ${getCheckedClass(
    checked,
    className
  )}`;

  return (
    <StyledRadioButton htmlFor={id} theme={theme}>
      <input
        id={id}
        name={name}
        value={value}
        type={type || "checkbox"}
        checked={checked}
        onChange={onChange}
        style={style}
        className="input"
      />

      <div className="checkbox-input">
        <div className={svgBlockClass}>{getIcon()}</div>
      </div>

      {label && <span>{label}</span>}
    </StyledRadioButton>
  );
};

export default RadioButton;
